import React, { useState } from "react";
import axios from "../../api/axios";
import { Grid, Paper, Button, TextField, MenuItem, Snackbar, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function InitiateVariation() {
  const [category, setCategory] = useState("");
  const [file, setFile] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const categories = [
    { value: "staff_id_data", label: "Staff ID Data" },
    { value: "staff_bio_data", label: "Staff Bio Data" },
    { value: "bank_details", label: "Bank Details" },
    { value: "pfa_details", label: "PFA Details" },
  ];

  const handleUpload = async () => {
    if (!category || !file) {
      setSnackbar({
        open: true,
        message: "Please select a category and upload a file.",
        severity: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`/variations/upload/${category}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSnackbar({
        open: true,
        message: res.data.message || "Upload successful",
        severity: "success",
      });
      setCategory("");
      setFile(null);
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "Upload failed. Please check the file and try again.",
        severity: "error",
      });
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Paper sx={{ p: 3, maxWidth: 600, margin: "auto", borderRadius: 3 }}>
          <Typography variant="h5" mb={2}>
            Initiate Variation
          </Typography>

          <TextField
            select
            fullWidth
            label="Variation Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            margin="normal"
          >
            <MenuItem value="">
              <em>-- Select Category --</em>
            </MenuItem>
            {categories.map((c) => (
              <MenuItem key={c.value} value={c.value}>
                {c.label}
              </MenuItem>
            ))}
          </TextField>

          <Button variant="outlined" component="label" fullWidth sx={{ mt: 2, mb: 2 }}>
            {file ? file.name : "Select Excel File"}
            <input
              type="file"
              accept=".xlsx, .xls"
              hidden
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Button>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleUpload}
            sx={{ color: "#fff" }}
          >
            Upload Variation
          </Button>
        </Paper>
      </MDBox>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default InitiateVariation;
